<template>
<el-dialog class='upgrade-project-dialog' :title="$t(operator === 'upgrade' ? 'upgradeProject' : 'unlockProject')" size="small" @close='close' :visible.sync='dialogVisable'>
  <p>
    {{operator === 'upgrade' ? $t('upgradeHint') : $t('unlockHint')}}
  </p>
  <div class='has-quotas' v-if="permanentsLeft !== 0">
    <el-checkbox theme="info" :checked="true" :disabled="true">
      使用账号额度（{{permanentsLeft === null ? '不限次数' : `还剩${permanentsLeft}次`}}）
    </el-checkbox>
  </div>
  <el-form label-thin label-width="66px" v-else-if="!organization">
    <el-form-item label="金额">
      <el-radio-group theme='info' class='package-type' v-model="packageType">
        <el-radio-button label='one_time_permanent_logo' v-if="!logoEnabled">
          ￥99/永久{{$t('common.project')}}+去除加载页LOGO <span class='recommand'>限时优惠</span>
        </el-radio-button>
        <el-radio-button label='one_time_permanent'>
          ￥49/{{$t('common.project')}}
        </el-radio-button>
      </el-radio-group>
      <a class='price-link' href='/price?closeOnPQuota=true' target='_blank'><i class='ppj-icon-gift'></i>升级会员，套餐更优惠</a>
    </el-form-item>
    <el-form-item :label="$t('common.order.labels.payType')">
      <el-radio-group theme='info' class='payment' v-model='payType'>
        <el-radio-button label='wechat'>{{$t('common.order.wechat')}}</el-radio-button>
        <el-radio-button label='alipay'>{{$t('common.order.alipay')}}</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </el-form>
  <div v-else>
    <p style='color:red;' v-if="overdate">企业套餐已过期，请联系管理员续费或升级</p>
    <p style='color:red;' v-else>企业套餐额度不足，请联系管理员续费或升级</p>
  </div>

  <span slot="footer" class="dialog-footer">
      <div v-if="organization && permanentsLeft === 0">
          <el-button type="primary" @click="close()">{{$t('common.buttons.cancel')}}</el-button>
      </div>
      <div v-else>
          <el-button type='text' @click="close()">{{$t('common.buttons.cancel')}}</el-button>
          <el-button type="primary" @click="placeOrder()">{{$t('common.buttons.submit')}}</el-button>
      </div>
  </span>
</el-dialog>
</template>

<i18n>
{
  "zh-cn": {
    "upgradeProject": "升级@:common.project",
    "unlockProject": "解锁@:common.project",
    "upgradeHint": "升级为永久@:common.project可以保证链接长期有效，解除付费阅读、更新PPT等限制",
    "unlockHint": "解除@:common.project无法更新PPT的限制",
    "upgradeComplete": "该@:common.project已成功升级为永久@:common.project！",
    "unlockComplete": "该@:common.project已解除锁定！"
  }
}
</i18n>

<script>
export default {
  data() {
    return {
      operator: 'upgrade', // could be 'unlock'
      dialogVisable: false,
      payType: 'wechat',
      projectId: null,
      success: null,
      logoEnabled: false,
      packageType: 'one_time_permanent'
    }
  },
  computed: {
    permanentsLeft() {
      return this.$store.state.quota.summary.permanents_left
    },
    overdate() {
      return this.$store.getters['quota/overdate']
    }
  },
  methods: {
    open(params) {
      let vm = this
      // set config
      vm.projectId = params.projectId
      vm.operator = params.operator || 'upgrade'
      vm.success = params.success || function() {}
      vm.logoEnabled = params.logoEnabled || false

      if (!vm.logoEnabled) {
        vm.packageType = 'one_time_permanent_logo'
      }

      vm.$store.dispatch('refresh').then(_ => {
        vm.dialogVisable = true
      })
    },
    close() {
      this.dialogVisable = false
      this.projectId = null
      this.success = null
    },
    placeOrder() {
      let vm = this

      let success = () => {
        vm.$message(vm.$t(vm.operator === 'upgrade' ? 'upgradeComplete' : 'unlockComplete'))

        if (typeof vm.success === 'function') {
          vm.success()
        }
        vm.close()
      }

      if (vm.permanentsLeft !== 0) {
        // directly use quotas to unlock
        vm.$store.dispatch('quota/consume', {
          key: 'permanent',
          project_id: vm.projectId
        }).then(success)
      } else {
        vm.$order({
          package: vm.packageType,
          project_id: vm.projectId,
          payment_method: vm.payType,
          success: success
        })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.upgrade-project-dialog {
    .el-form-item {
        margin-bottom: 0.5em;
    }

    .package-type {
        white-space: nowrap;
    }

    .recommand {
        color: $color-primary;
        font-size: $font-size-small;
    }

    .has-quotas {
        margin: 2em 0;
    }

    .price-link {
        color: $color-primary;
        .ppj-icon-gift {
            margin-right: 0.4em;
        }
        &:focus,
        &:hover {
            color: lighten($color-primary, 10%);
        }
    }
}
</style>



// WEBPACK FOOTER //
// upgrade.dialog.vue?6e7083fe